import {
  baseScreen,
} from 'hoc';
import {
  useObserver,
} from 'mobx-react';
import React from 'react';

const systemSetup: React.FC = () => useObserver(() => (
  <div>
    systemSetup
  </div>
));

export const SystemSetup = baseScreen(systemSetup, {
  allowedRoles: ['ADMIN', 'NONE'],
});
